import React from 'react';
import BulletList from './BulletList';
import ContactLinks from './ContactLinks';

const LegalSubsection = ({ title, paragraphs, bullets, subsections, contact, index }) => {
  const headingId = title
    ? `${title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')}-${index}`
    : undefined;

  return (
    <section className="legal-subsection" aria-labelledby={headingId}>
      {title && (
        <h3 id={headingId} className="legal-subsection__title">
          {index != null ? `${index}. ` : ''}
          {title}
        </h3>
      )}

      {paragraphs?.map((paragraph) => (
        <p key={paragraph} className="legal-subsection__paragraph">
          {paragraph}
        </p>
      ))}

      {bullets && <BulletList items={bullets} />}

      {subsections?.map((subsection) => (
        <div key={subsection.title} className="legal-subsection__nested">
          <h4 className="legal-subsection__nested-title">{subsection.title}</h4>
          {subsection.bullets && <BulletList items={subsection.bullets} />}
          {subsection.paragraphs?.map((paragraph) => (
            <p key={paragraph} className="legal-subsection__paragraph">
              {paragraph}
            </p>
          ))}
        </div>
      ))}

      {contact && <ContactLinks />}
    </section>
  );
};

export default LegalSubsection;
